import { lazy } from "react";

const Volume = lazy(() => import("@views/TimeEstimation/Volume"));
const Print = lazy(() => import("@views/TimeEstimation/Volume/Print"))
const AEstimation = lazy(() => import("@views/TimeEstimation/AEstimation"))
const Prints = lazy(() => import("@views/TimeEstimation/AEstimation/Print"))
const PartTime = lazy(() => import("@views/TimeEstimation/PartTime"))
const PartTimePrint = lazy(() => import("@views/TimeEstimation/PartTime/Print"))

const TimeEstimate = [
	{
		path: "/volume",
		element: <Volume />,
	},
	{
        path: '/volume/print/',
        element: <Print />,
        meta: {
            layout: 'blank'
        },
    },
    {
		path: "/a_estimation",
		element: <AEstimation />,
	},
	{
        path: '/a_estimation/print/',
        element: <Prints />,
        meta: {
            layout: 'blank'
        },
    },

    {
        path: '/part-time/',
        element: <PartTime />,
    },

    {
        path: '/part-time/print/',
        element: <PartTimePrint />,
        meta: {
            layout: 'blank'
        },
    },
];
export default TimeEstimate;
